export { default } from './DomainConfigError.jsx'



// WEBPACK FOOTER //
// ./src/components/common/DomainConfigError/index.js